import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ConfigurationService } from 'projects/zbs-app/src/app/components/configuration-select/configuration.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HierarchyNodes } from '../../../services/Ebootis.Queries/HierarchyNodes';


@Component({
  selector: 'app-node-select',
  templateUrl: './node-select.component.html',
  styleUrls: ['./node-select.component.scss'],

})
export class NodeSelectComponent {
  @Input() required: boolean = false;
  @Input() set level(value: number) {
    if (this.m_level != value) {
      this.m_level = value;
      this.getNodes();
    }
  }
  @Input() nodeControl: UntypedFormControl;
  @Input() set includeAllUsers(p_value: boolean) {
    this.m_includeAllUsers = p_value;
    this.getNodes();
  }
  private m_includeAllUsers: boolean = false;
  @Input() set parentNode(value: string) {
    if (this.m_parentNode != value) {
      this.m_parentNode = value;
      this.getNodes();
    }
  }
  @Input() autocomplete: boolean = false;
  @Output() nodeChanged: EventEmitter<string> = new EventEmitter();
  private m_subscriptionsSubject = new Subject();
  public m_nodeResult: string[] = [];
  public m_level: number = 1;
  private m_parentNode: string = null;
  constructor(
    private m_cfgService: ConfigurationService,
    private hierarchyNodesForCustomerSearch: HierarchyNodes,
  ) { }

  ngOnInit() {
    this.getNodes();
  }

  ngOnDestroy(): void {
    this.m_subscriptionsSubject.next(null);
    this.m_subscriptionsSubject.complete();
  }

  getNodes() {
    this.hierarchyNodesForCustomerSearch.query({ config: this.m_cfgService.SelectedConfigOid, hierarchyLevel: this.m_level, includeAllUsers: this.m_includeAllUsers }).pipe(
      takeUntil(this.m_subscriptionsSubject)
    ).subscribe({
      next: (data) => {
        this.m_nodeResult = data && data.length > 0 ? data.sort((a, b) => {
          if (a > b)
            return 1;
          else if (a < b)
            return -1;
          else return 0;
        }) : data
      }
    })
  }

  /**
   * Setzt ein FormControl zurück.
   * @param p_controlName FormControlName
   */
  public clearInput_Click(): void {
    this.nodeControl.setValue('');
  }

}
